import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const api = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add auth token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle auth errors - DO NOT redirect on 401, let Clerk handle auth state
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Log the error but don't redirect - Clerk manages auth state
      console.log('API 401 error - token may need refresh');
      // Don't clear tokens or redirect - Clerk will handle re-authentication
    }
    return Promise.reject(error);
  }
);

export default api;
